module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-9.f721e309.jpg";